import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import DeleteMultipleClosedTicketsModal, {
  MultipleClosedTicketsRef,
} from './DeleteMultipleClosedTicketsModal';
import ticketListActions from 'features/ticketList/services/actions';
import { useAppDispatch } from 'store/hooks';
import { IStaffItemData } from 'services/shop/types/staff';
import { Button } from 'antd';
import { FeaturePermission } from 'constants/Permission';

const RevokedButton = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement> & { selectedRowKeys: string[] }
) => {
  const openDeleteMultipleClosedTicketsModal = useRef<MultipleClosedTicketsRef>(null);
  const [visiblePW, setVisiblePW] = useState(false);
  const dispatch = useAppDispatch();

  const showRequestAdminLocalPW = () => {
    setVisiblePW(true);
  };

  const onDeleteMultipleClosedTicketsSuccess = () => {
    dispatch(ticketListActions.afterDeleteClosedTicket());
  };

  const onVerifyAdminSuccess = (pin?: string, staffDataVerified?: IStaffItemData) => {
    setVisiblePW(false);
    const billIds = props.selectedRowKeys;
    const data = {
      billIds: billIds,
      staffDeleteId: staffDataVerified?.id || '',
    };
    openDeleteMultipleClosedTicketsModal.current?.open(data, onDeleteMultipleClosedTicketsSuccess);
  };

  return (
    <div>
      <Button {...props} type='primary' onClick={showRequestAdminLocalPW}>
        Revoked
      </Button>
      {visiblePW && (
        <RequestAdminLocalPW
          onlyAdmin
          visible
          v2={true}
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(false)}
          featureCode={FeaturePermission.DELETE_TICKET}
        />
      )}
      <DeleteMultipleClosedTicketsModal ref={openDeleteMultipleClosedTicketsModal} />
    </div>
  );
};

export default RevokedButton;

const StyledButton = styled.button`
  display: flex;
  height: 56px;
  padding: 0px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #6fabb6;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4), 0px 4px 8px -3px rgba(45, 35, 66, 0.3),
    0px -4px 0px 0px #144b55 inset;
  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:hover {
    opacity: 0.8;
  }
`;
